import { render, staticRenderFns } from "./error.vue?vue&type=template&id=107d26be&scoped=true&lang=pug&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=107d26be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d26be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderLayout: require('/home/node/components/layoutHome/HeaderLayout.vue').default})
